<template>
  <div>

    <v-select :filterable="false" @search="fetchOptions" v-model="selected" :options="options"
      :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { axiosMixin } from "@/mixin/axiosMixin.js";
import { mapGetters } from "vuex";
export default {
  mixins: [axiosMixin],
  data() {
    return {
      options: [
      ],
      selected: {},
    }
  },
  computed: {
    ...mapGetters({
      getGs: "main/getGs",
    })
  },
  watch: {
    selected(value) {
      this.$emit('input', value);
    },
    'getGs.compId': function (newVal, oldVal) {
      this.getmasterCode();
    },
    'getGs.stock': function (newVal, oldVal) {
      this.getmasterCode();
    }

  },
  components: {
    'v-select': vSelect,
  },
  mounted() {

    this.selected = this.getGs.masterStockCode;
    this.getmasterCode();
  },
  methods: {
    getmasterCode() {
      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc";
      this.options = [];
      this.aronPost("getMasterCode", { masterCode: "all", compId: this.getGs.compId, stockId: this.getGs.stock }, params, sort)
        .then(response => {
          console.log("date", response.data);
          if (response.status == 200) {
            this.options = response.data.masterStockCode;
          }

        })
        .catch(error => {
        });
    },
    fetchOptions(search, loading) {
      loading(true)
      // fetch data from server
      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc";
      this.options = [];
      this.aronPost("getMasterCode", { masterCode: search, compId: this.getGs.compId, stockId: this.getGs.stock }, params, sort)
        .then(response => {
          console.log("date", response.data);
          if (response.status == 200) {
            this.options = response.data.masterStockCode;
          }

          loading(false)
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          loading(false)
        });
    }
  }
}
</script>
